<template>
  <div id="carPresentList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>业务数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{navigationMap[reportActiveName]}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;"
                       @change="loadPark">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fInParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       @change="loadChannel"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道::">
            <el-select v-model="pageSearch.fInChnlID"
                       filterable
                       placeholder="请选择通道"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in channel_list"
                         :key="item.fChnlID"
                         :label="item.fChnlName"
                         :value="item.fChnlID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="padding-left:10px">
            <el-checkbox v-model="pageSearch.isPresent">只显示在场车辆</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="开始时间::">
          <el-date-picker v-model="startTime"
                          style="width:200px"
                          type="datetime"
                          :clearable="true"
                          format="yyyy-MM-dd HH:mm:ss"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间::">
          <el-date-picker v-model="endTime"
                          style="width:200px"
                          :clearable="true"
                          format="yyyy-MM-dd HH:mm:ss"
                          type="datetime"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="车牌::">
          <el-input placeholder="请输入车牌"
                    v-model="pageSearch.searchKeyWord"
                    class="search">
          </el-input>
        </el-form-item>
        <el-form-item label="车辆类型::">
          <el-select v-model="pageSearch.vehicleType"
                     placeholder="请选择车辆类型"
                     filterable>
            <el-option v-for="item in vehicleTypes"
                       :key="item.value"
                           :label="item.label"
                           :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     size="small"
                     icon="el-icon-search"
                     @click="page_list">查询</el-button>
          <el-button type="warning"
                     size="small"
                     icon="el-icon-search"
                     @click="page_sensitive_list">敏感车牌</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row class="tabRow">
      <el-tabs v-model="reportActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="在场数据"
                     name="pageData">
          <el-row>
            <el-table :data="pageData"
                      :height="tableHeight"
                      highlight-current-row
                      v-loading="loading"
                      border
                      stripe
                      style="width: 100%">
              <el-table-column width="50"
                               type="index"
                               :index="indexMethod"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fInTime"
                               width="160"
                               label="进场时间">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="100"
                               label="车牌号码">
                 <template slot-scope="scope">
                      <el-link v-if="scope.row.fCardID!='0'" type="primary"  @click="viewCard(scope.row)">{{scope.row.fPlateCode}}</el-link>
                      <span v-else>{{scope.row.fPlateCode}}</span>
                 </template>
              </el-table-column>
              <el-table-column prop="fPlateColor"
                               width="80"
                               label="车牌颜色">
              </el-table-column>
              <!-- <el-table-column prop="fConfidence"
                           width="80"
                           label="车牌来源">
          </el-table-column>
          <el-table-column prop="fCarTypeName"
                           width="80"
                           label="车辆类型">
          </el-table-column> -->
              <el-table-column prop="fIsCard"
                               width="115"
                               label="是否月车">
              </el-table-column>
              <el-table-column
                              label="进场场库">
                        <template slot-scope="scope">
                             <el-link type="primary"  @click="viewParkInfo(scope.row)">{{scope.row.fInParkName}}</el-link>
                        </template>
              </el-table-column>
              <el-table-column prop="fInChnlName"
                               label="进场通道">
              </el-table-column>
              <el-table-column prop="fInStatus"
                               width="90"
                               label="进场方式">
              </el-table-column>
              <el-table-column prop="fRateGroupName"
                               label="费率名称">
              </el-table-column>
              <el-table-column prop="fInRemark"
                               label="进场备注">
              </el-table-column>
              <el-table-column label="操作"
                               fixed="right"
                               align="center"
                               width="160">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="success"
                             @click="handleInfo(scope.$index, scope.row)">查看</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synPageData">
          <el-row>
            <el-table :data="synPageData"
                      :height="tableHeight"
                      highlight-current-row
                      v-loading="loading"
                      border
                      stripe
                      style="width: 100%">
              <el-table-column width="50"
                               type="index"
                               :index="indexMethod"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fInTime"
                               width="160"
                               label="进场时间">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               width="100"
                               label="车牌号码">
                  <template slot-scope="scope">
                             <el-link v-if="scope.row.fCardID!='0'" type="primary"  @click="viewCard(scope.row)">{{scope.row.fPlateCode}}</el-link>
                             <span v-else>{{scope.row.fPlateCode}}</span>
                  </template>
              </el-table-column>
              <el-table-column prop="fPlateColor"
                               width="80"
                               label="车牌颜色">
              </el-table-column>
              <!-- <el-table-column prop="fConfidence"
                           width="80"
                           label="车牌来源">
          </el-table-column>
          <el-table-column prop="fCarTypeName"
                           width="80"
                           label="车辆类型">
          </el-table-column> -->
              <el-table-column prop="fIsCard"
                               width="80"
                               label="是否月车">
              </el-table-column>
               <el-table-column
                              label="进场场库">
                        <template slot-scope="scope">
                             <el-link type="primary"  @click="viewParkInfo(scope.row)">{{scope.row.fInParkName}}</el-link>
                        </template>
              </el-table-column>
              <el-table-column prop="fInChnlName"
                               label="进场通道">
              </el-table-column>
              <el-table-column prop="fInStatus"
                               width="90"
                               label="进场方式">
              </el-table-column>
              <el-table-column prop="fRateGroupName"
                               label="费率名称">
              </el-table-column>
              <el-table-column prop="fInRemark"
                               label="进场备注">
              </el-table-column>
              <el-table-column label="操作"
                               fixed="right"
                               align="center"
                               width="250">
                <template slot-scope="scope">
                  <el-button size="mini"
                             type="success"
                             @click="handleInfo(scope.$index, scope.row)">查看</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_del"
                             @click="synReport(scope.$index, scope.row)">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <el-col :span="24">

      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <div class="pagination-left"><label>{{statisticsMsg}}</label></div>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout=" total, sizes,prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <carInfoView ref="child"
                 :reportActiveName="reportActiveName"
                 :type="1"></carInfoView>
    <parkView ref="childPark"
              :parkActiveName="parkActiveName"
              :choiceCusts="cust_list"></parkView>
    <cardView ref="childCard"
              cardActiveName="cardList"
              :choiceCusts="cust_list"></cardView>
  </div>
</template>
<script>
import cardView from '../../components/cardView'
import parkView from '../../components/parkView'
import carInfoView from '../../components/carInfoView'
import { report as api, report } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  components: {carInfoView, parkView, cardView},
  data () {
    return {
      is_del: false,
      is_export: false,
      tableHeight: 0,
      loading: false,
      navigationMap: {
        pageData: '在场数据',
        synPageData: '待同步'
      },
      parkActiveName: 'parkList',
      export_loading: false,
      export_msg: '导出',
      reportActiveName: 'pageData',
      synPageData: [],
      pageData: [],
      cust_list: [],
      park_list: [],
      channel_list: [],
      pageCount: 0,
      statisticsMsg: '',
      place: {},
      startTime: '',
      endTime: '',
      pageSearch: {
        isPresent: true,
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fInParkID: '',
        fInChnlID: '',
        fstartTime: '',
        fendTime: '',
        searchKeyWord: '',
        isSync: false,
        vehicleType: -1
      },
      vehicleTypes: [{ value: -1, label: '所有车辆' }, { value: 0, label: '临时车' }, { value: 1, label: '包月车' }]
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_sensitive_list () {
      park.getParkSensitivePlateCode({ fCustID: this.pageSearch.fCustID, fParkID: this.pageSearch.fInParkID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if ((data.Data || '').length > 0) {
              this.pageSearch.searchKeyWord = data.Data
            } else {
              this.pageSearch.searchKeyWord = '-'
            }
            this.page_list(0)
          }
        }
      })
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.pageSearch.isSync = this.reportActiveName === 'synPageData'
      this.loading = true
      this.pageSearch.fstartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      api.carPresentList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (this.pageSearch.isSync) {
              this.synPageData = data.Data.data
            } else {
              this.pageData = data.Data.data
            }
            this.pageCount = data.Data.count
            this.statisticsMsg = '总车位数：' + data.Data.place.totalPlace + ' | 在场车辆：' + data.Data.place.prePlace + ' | 剩余车位：' + data.Data.place.remainPlace
          } else {
            this.$message.error('提示：加载在场数据失败')
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.pageSearch.fstartTime = ''
      if ((this.startTime || '').toString().trim().length > 0) {
        this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.fendTime = ''
      if ((this.endTime || '').toString().trim().length > 0) {
        this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.pageSearch.isSync = this.reportActiveName === 'synPageData'
      report.carPresentExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_在场数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    viewParkInfo (row) {
      this.$refs.childPark.viewPark(row, true, row.fInParkID)
    },
    viewCard (row) {
      this.$refs.childCard.viewCard(row, true)
    },
    loadPark (fCustID) {
      this.pageSearch.fInParkID = ''
      this.park_list = []
      this.pageSearch.fInChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    loadChannel (fInParkID) {
      this.pageSearch.fInChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fInParkID) { return }
      // 加载通道
      park.channelList({ fParkID: fInParkID, fCustID: this.pageSearch.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.channel_list = data.Data
            // console.log(this.channel_list)
            // if (this.channel_list && this.channel_list.length > 0) {
            //   this.pageSearch.fInChnlID = this.channel_list[0].fChnlID
            // }
          } else {
            this.$message.error('提示：加载通道列表失败')
          }
        }
      })
    },
    changeChannel (val) {
      // 加载在场数据列表
      this.page_list()
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    tabClick () {
      this.pageCount = 0
      this.page_list()
    },
    deleteInfo (index, row) {
      this.$confirm('请确认是否删除[车牌:' + row.fPlateCode + ' 进场时间:' + row.fInTime + ']在场记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteCarPresent({ fBigRowID: row.fBigRowID, isSync: (this.reportActiveName === 'synPageData') }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.page_list()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    synReport (index, row) {
      this.$confirm('将[车牌:' + row.fPlateCode + ' 进场时间:' + row.fInTime + ']在场记录同步到线下客户端进行永久删除', '是否继续 ? ', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.syncCarPresent({ fBigRowID: row.fBigRowID }).then(res => {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '操作完成'
              })
              this.page_list()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 280
      obj.tableHeight = clientHeight
      this.setImgHeight()
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 60000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_del = data.Data.data.is_del
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>

/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination-left {
  float: left;
}
.pagination-left > label {
  font-size: 13px;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  line-height: 28px;
  height: 28px;
}
.el-pagination {
  float: right;
}

.pagination {
  /* text-align: right; */
  padding-top: 5px;
}
.search {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/report/carPresentList.vue